import { render, staticRenderFns } from "./BootstrapTable.vue?vue&type=template&id=237e5470&scoped=true&"
import script from "./BootstrapTable.vue?vue&type=script&lang=js&"
export * from "./BootstrapTable.vue?vue&type=script&lang=js&"
import style0 from "./BootstrapTable.vue?vue&type=style&index=0&id=237e5470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237e5470",
  null
  
)

export default component.exports